<template>
<Dropdown class="c-dropdown" :transfer="true" trigger="click">
	<slot></slot>
	<DropdownMenu slot="list" class="dropdown">
        <div @click.stop class="dropdown-tool">
            <Input class="dropdown-search" v-model.trim="keyword" placeholder="请输入关键字"/>
            <a @click="changeFilterList(false)" class="blue-btn">清除</a>
            <a @click="changeFilterList(true)" class="blue-btn">全选</a>
        </div>
        <div hidden>{{returnString}}{{updateStatus}}</div>
		<DropdownItem v-for="item in filterList" :key="item[code]">
            <div @click.stop="item.selected=!item.selected" class="dropdown-item">
                <p class="dropdown-item-left showregular">{{item[label]}}</p>
                <div class="dropdown-item-right">
                    <i class="icon icon-checkbox" :class="{active:item.selected}"></i>
                </div>
            </div>
        </DropdownItem>
	</DropdownMenu>
</Dropdown>
</template>
<script>
/*
 * @desc 通用下拉多选
 * @param {String} value 双向绑定的值，暂只支持逗号分隔字符串
 * @param {Array} sourceList 源选项列表
 * @param {String} label 显示的字段名
 * @param {String} code 输出的字段值
 * @param {String} status 选择的状态文字
 * @tips：请在sourceList初始化后再渲染该组件，防止多次应用sourceList产生数据污染
 */
export default {
    name: 'cDropdown',
    props: {
        value: {
            type: String
        },
        sourceList: {
            type: Array,
            default: () => []
        },
        code: {
            type: String
        },
        label: {
            type: String
        },
        status: {
            type: String
        }
    },
    data() {
        return {
            keyword: '', //筛选关键字
            list: [] //复制的选项列表
        };
    },
    computed: {
        //关键字过滤后的列表
        filterList() {
            return this.list.filter(item => item[this.label].toUpperCase().includes(this.keyword.toUpperCase()));
        },
        //已选择的数量
        selectedCount() {
            return this.list.filter(item => item.selected).length;
        },
        //是否全选
        selectedAll() {
            return this.list.length ? this.list.every(item => item.selected) : false;
        },
        //当前显示内容
        updateStatus() {
            const status = this.selectedAll || !this.selectedCount ? '全部' : `已选${this.selectedCount}项`;
            this.$emit('update:status', status);
            return status;
        },
        //返回的字符串
        returnString() {
            let value = '';
            if (!this.selectedAll && this.selectedCount) {
                value = this.list
                    .filter(item => item.selected)
                    .map(item => item[this.code])
                    .join(',');
            }
            this.$emit('input', value);
            return value;
        }
    },
    watch: {
        sourceList: {
            handler: function(newValue) {
                //初始化selected状态
                const selectedArr = this.value.split(',');
                this.list = newValue.map(item => {
                    const bool = selectedArr.includes(`${item[this.code]}`);
                    return Object.assign({ selected: bool }, item);
                });
            },
            immediate: true
        }
    },
    mounted() {},
    methods: {
        /*
         * @description 修改当前所有推广的状态
         * @param bool:boolean 要修改成的状态
         */
        changeFilterList(bool) {
            this.filterList.forEach(item => (item.selected = bool));
        }
    }
};
</script>
<style lang="scss">
.dropdown {
    .dropdown-tool {
        display: flex;
        align-items: center;
        padding: 0 0.1rem 0.1rem 0.1rem;
        .dropdown-search {
            flex: 1 1 auto;
        }
        .blue-btn {
            flex: 0 0 auto;
            margin-left: 0.15rem;
            color: #237ec5;
            font-size: 0.14rem;
        }
    }
    .ivu-dropdown-item {
        padding: 0;
        .dropdown-item {
            display: flex;
            line-height: 0.36rem;
            padding: 0 0.1rem;
            justify-content: space-between;
            align-items: center;
            &:hover {
                background: #f3f3f3;
            }
            .dropdown-item-left {
                flex: 1 1 auto;
            }
            .dropdown-item-right {
                flex: 0 0 0.4rem;
                display: flex;
                justify-content: flex-end;
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/components/commons/cDropdown.vue